<template>
  <ContentList :list="materialsAndCareBullets">
    <template #default="{ item }">
      <div v-if="item.type === 'TEXT'" data-testid="itemTypeText" v-html="item.text"></div>
      <div v-else-if="item.type === 'LABEL_DISCLOSURE'" class="inline-content" data-testid="itemTypeLabelDisclosure">
        <span data-testid="itemTextLabelDisclosure">{{ item.text }}</span>
        <button
          class="learn-more-button"
          aria-label="Learn More about Materials & Care"
          aria-controls="legal-disclosure-drawer"
          @click.prevent="openCustomPopup"
        >
          <span>Learn More</span>
        </button>
      </div>
    </template>
  </ContentList>
</template>

<script setup>
import { defineAsyncComponent, markRaw } from 'vue';
import ContentList from '~/components/common/ContentList';
import { useSlideout } from '~/composables/utils/useSlideout';
import { useProductDetails } from '../composables/useProductDetails';

const props = defineProps({
  openAsInitialSlideout: {
    type: Boolean,
    default: true,
  },
});

const { materialsAndCareBullets, availableUpcs } = useProductDetails();
const { showSlideout, addSlideout } = useSlideout();

function openCustomPopup() {
  const config = {
    id: 'product-details-drawer',
    title: 'Product Fill Legal Disclosure',
    props: { availableUpcs },
    component: markRaw(
      defineAsyncComponent(
        /* istanbul ignore next */ () => import(/* webpackChunkName: "[request]" */ './slideouts/ProductFillLegalDisclosureDrawer.vue'),
      ),
    ),
    backable: !props.openAsInitialSlideout,
  };

  return props.openAsInitialSlideout ? showSlideout(config) : addSlideout(config);
}
</script>

<style lang="scss" scoped>
.learn-more-button > span {
  text-decoration: underline;
  cursor: pointer;
  margin-left: 4px;
}
</style>
